var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "h-100-pct bg-white",
      staticStyle: { "padding-bottom": "0", "margin-bottom": "0" },
    },
    [
      _c(
        "v-layout",
        {
          class: {
            "pl-16 pr-16": _vm.mdAndUp,
          },
          attrs: { row: "", wrap: "", id: "truckload-quote-layout" },
        },
        [
          _c(
            "v-flex",
            {
              staticClass: "ta-c",
              class: {
                "pt-14": _vm.mdAndUp,
                "pt-8 pb-7": _vm.smAndDown,
              },
              attrs: { xs12: "", sm12: "", md12: "", lg12: "", xl12: "" },
            },
            [
              _c("label", { staticClass: "create-quote-title" }, [
                _vm._v("Truckload Quote Request"),
              ]),
            ]
          ),
          _c(
            "v-flex",
            {
              staticClass: "ta-c",
              class: {
                "pt-6": _vm.mdAndUp,
                "pt-4": _vm.smAndDown,
              },
              attrs: { xs12: "", sm12: "", md12: "", lg12: "", xl12: "" },
            },
            [
              _c("label", { staticClass: "quote-sub-header" }, [
                _vm._v("Do you need a quote to send?"),
              ]),
            ]
          ),
          _c(
            "v-flex",
            {
              staticClass: "ta-c",
              class: {
                "pt-4": _vm.mdAndUp,
                "pt-2": _vm.smAndDown,
              },
              attrs: { xs12: "", sm12: "", md12: "", lg12: "", xl12: "" },
            },
            [
              _c("p", { staticClass: "quote-description" }, [
                _vm._v(
                  " Fill out the form below and one of our representatives will contact you shortly."
                ),
                _c("br"),
                _vm._v(
                  " If you are in immediate need to send your freight, please feel free to contact our"
                ),
                _c("br"),
                _vm._v(" Customer Service Team at "),
                _c("span", { staticClass: "phone-number" }, [
                  _vm._v("(866) 475-2374"),
                ]),
                _vm._v(" (Mon-Fri, 7:00 am to 6:00 pm CST). "),
              ]),
            ]
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c("TruckQuoteContactInformation", {
                ref: "contactInfo",
                attrs: {
                  "show-error": _vm.showContactError,
                  "missing-fields": _vm.contactMissingFields,
                },
                on: {
                  "update:showError": function ($event) {
                    _vm.showContactError = $event
                  },
                  "update:show-error": function ($event) {
                    _vm.showContactError = $event
                  },
                  "update:missingFields": function ($event) {
                    _vm.contactMissingFields = $event
                  },
                  "update:missing-fields": function ($event) {
                    _vm.contactMissingFields = $event
                  },
                },
                model: {
                  value: _vm.contactInfo,
                  callback: function ($$v) {
                    _vm.contactInfo = $$v
                  },
                  expression: "contactInfo",
                },
              }),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md8: "",
                lg6: "",
                xl6: "",
                "offset-md2": "",
                "offset-lg3": "",
                "offset-xl3": "",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [_c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-6 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c("TruckQuoteOriginInformation", {
                ref: "originInfo",
                attrs: {
                  "show-error": _vm.showOriginError,
                  "missing-fields": _vm.originMissingFields,
                },
                on: {
                  "update:showError": function ($event) {
                    _vm.showOriginError = $event
                  },
                  "update:show-error": function ($event) {
                    _vm.showOriginError = $event
                  },
                  "update:missingFields": function ($event) {
                    _vm.originMissingFields = $event
                  },
                  "update:missing-fields": function ($event) {
                    _vm.originMissingFields = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "location",
                    fn: function () {
                      return [
                        _c("smart-text-field", {
                          attrs: {
                            placeholder: "Shipper Name",
                            required: true,
                            "show-error": _vm.showOriginError,
                            "missing-fields": _vm.originMissingFields,
                            "field-name": "Shipper Name",
                            icon: _vm.ic_card_blue,
                            "icon-slot": "inner",
                            "icon-position": "right",
                            "icon-class": "mr-2 mt-1 hover address-book-icon",
                            "icon-width": "24",
                          },
                          on: {
                            "icon-click": function ($event) {
                              _vm.showOrigAddressBookPopup = true
                            },
                          },
                          model: {
                            value: _vm.originInfo.location,
                            callback: function ($$v) {
                              _vm.$set(_vm.originInfo, "location", $$v)
                            },
                            expression: "originInfo.location",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.originInfo,
                  callback: function ($$v) {
                    _vm.originInfo = $$v
                  },
                  expression: "originInfo",
                },
              }),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md8: "",
                lg6: "",
                xl6: "",
                "offset-md2": "",
                "offset-lg3": "",
                "offset-xl3": "",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [_c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c("TruckQuoteDestinationInformation", {
                ref: "destinationInfo",
                attrs: {
                  "show-error": _vm.showDestinationError,
                  "missing-fields": _vm.destinationMissingFields,
                },
                on: {
                  "update:showError": function ($event) {
                    _vm.showDestinationError = $event
                  },
                  "update:show-error": function ($event) {
                    _vm.showDestinationError = $event
                  },
                  "update:missingFields": function ($event) {
                    _vm.destinationMissingFields = $event
                  },
                  "update:missing-fields": function ($event) {
                    _vm.destinationMissingFields = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "location",
                    fn: function () {
                      return [
                        _c("smart-text-field", {
                          attrs: {
                            placeholder: "Receiver Name",
                            required: true,
                            "show-error": _vm.showDestinationError,
                            "missing-fields": _vm.destinationMissingFields,
                            "field-name": "Receiver Name",
                            icon: _vm.ic_card_blue,
                            "icon-slot": "inner",
                            "icon-position": "right",
                            "icon-width": "24",
                            "icon-class": "mr-2 mt-1 hover address-book-icon",
                          },
                          on: {
                            "icon-click": function ($event) {
                              _vm.showDestAddressBookPopup = true
                            },
                          },
                          model: {
                            value: _vm.destinationInfo.location,
                            callback: function ($$v) {
                              _vm.$set(_vm.destinationInfo, "location", $$v)
                            },
                            expression: "destinationInfo.location",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.destinationInfo,
                  callback: function ($$v) {
                    _vm.destinationInfo = $$v
                  },
                  expression: "destinationInfo",
                },
              }),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md8: "",
                lg6: "",
                xl6: "",
                "offset-md2": "",
                "offset-lg3": "",
                "offset-xl3": "",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [_c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "TruckQuoteServiceInformation",
                {
                  ref: "serviceInfo",
                  attrs: {
                    "show-error": _vm.showServiceError,
                    "missing-fields": _vm.serviceMissingFields,
                  },
                  on: {
                    "update:showError": function ($event) {
                      _vm.showServiceError = $event
                    },
                    "update:show-error": function ($event) {
                      _vm.showServiceError = $event
                    },
                    "update:missingFields": function ($event) {
                      _vm.serviceMissingFields = $event
                    },
                    "update:missing-fields": function ($event) {
                      _vm.serviceMissingFields = $event
                    },
                    "pickup-date-changed": _vm.pickupDateChanged,
                    "delivery-date-changed": _vm.deliveryDateChanged,
                  },
                  model: {
                    value: _vm.serviceInfo,
                    callback: function ($$v) {
                      _vm.serviceInfo = $$v
                    },
                    expression: "serviceInfo",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("smart-combobox", {
                            attrs: {
                              items: _vm.equipmentTypesDdl,
                              label: "Equipment Type",
                              required: true,
                              "show-error": _vm.showServiceError,
                              "missing-fields": _vm.serviceMissingFields,
                              "field-name": "Equipment Type",
                            },
                            model: {
                              value: _vm.serviceInfo.equipmentType,
                              callback: function ($$v) {
                                _vm.$set(_vm.serviceInfo, "equipmentType", $$v)
                              },
                              expression: "serviceInfo.equipmentType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md8: "",
                lg6: "",
                xl6: "",
                "offset-md2": "",
                "offset-lg3": "",
                "offset-xl3": "",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [_c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c("TruckQuoteCommodityInformation", {
                ref: "commodityInfo",
                attrs: {
                  "show-error": _vm.showCommodityError,
                  "missing-fields": _vm.missingFields,
                  "equipment-type": _vm.serviceInfo.equipmentType,
                  "equipment-types-ddl": _vm.equipmentTypesDdl,
                },
                on: {
                  "update:showError": function ($event) {
                    _vm.showCommodityError = $event
                  },
                  "update:show-error": function ($event) {
                    _vm.showCommodityError = $event
                  },
                  "update:missingFields": function ($event) {
                    _vm.missingFields = $event
                  },
                  "update:missing-fields": function ($event) {
                    _vm.missingFields = $event
                  },
                  "update:equipmentType": function ($event) {
                    return _vm.$set(_vm.serviceInfo, "equipmentType", $event)
                  },
                  "update:equipment-type": function ($event) {
                    return _vm.$set(_vm.serviceInfo, "equipmentType", $event)
                  },
                },
                model: {
                  value: _vm.commodities,
                  callback: function ($$v) {
                    _vm.commodities = $$v
                  },
                  expression: "commodities",
                },
              }),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md8: "",
                lg6: "",
                xl6: "",
                "offset-md2": "",
                "offset-lg3": "",
                "offset-xl3": "",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [_c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "section-heading" }, [
                      _vm._v("Additional Information"),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-textarea", {
                        attrs: {
                          label: "Add a note",
                          maxlength: "500",
                          rows: "6",
                          "hide-details": false,
                        },
                        model: {
                          value: _vm.additionalNotes,
                          callback: function ($$v) {
                            _vm.additionalNotes = $$v
                          },
                          expression: "additionalNotes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            {
              staticClass: "mb-10",
              class: {
                "pl-16 pt-8 pr-16": _vm.mdAndUp,
                "pl-8 pr-6 pt-2": _vm.smAndDown,
              },
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                xl6: "",
                "offset-xl3": "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "submit-control",
                  class: {
                    "pb-10 pt-2": _vm.mdAndUp,
                    "pt-6 pb-10": _vm.smAndDown && !_vm.submitting,
                    "pt-2 pb-10": _vm.smAndDown && _vm.submitting,
                  },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-right", attrs: { cols: "12" } },
                    [
                      _c("smart-btn", {
                        staticClass: "mr-4",
                        attrs: {
                          type: "secondary",
                          outlined: "",
                          label: "CLEAR",
                        },
                        on: { click: _vm.onClearClick },
                      }),
                      _c("smart-btn", {
                        staticStyle: { width: "85px" },
                        attrs: {
                          type: "primary",
                          label: "SUBMIT",
                          loading: _vm.submitting,
                        },
                        on: { click: _vm.submitQuoteRequest },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-overlay",
            {
              attrs: { value: _vm.submitting, opacity: "0.75", color: "#fff" },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "ta-c" },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "64",
                          color: "primary",
                        },
                      }),
                      _c("p", { staticClass: "overlay-txt mt-7" }, [
                        _vm._v("Submitting your request..."),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500" },
              model: {
                value: _vm.showSuccessDialog,
                callback: function ($$v) {
                  _vm.showSuccessDialog = $$v
                },
                expression: "showSuccessDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "br-10 px-5 pt-5 pb-6" },
                [
                  _c("v-card-title", { staticClass: "justify-center" }, [
                    _c(
                      "label",
                      { staticClass: "headline base header modal-popup-title" },
                      [_vm._v("Pending Order Created")]
                    ),
                  ]),
                  _c("v-card-text", { staticClass: "ta-c pt-5 pb-2" }, [
                    _c("label", { staticClass: "base" }, [
                      _vm._v(
                        "Your pending Spot Market Bid order has been successfully created."
                      ),
                    ]),
                    _vm.pendingOrderId
                      ? _c("p", { staticClass: "mt-5" }, [
                          _c(
                            "label",
                            {
                              staticClass: "base",
                              staticStyle: { "font-size": "16px" },
                            },
                            [_vm._v("Pending Order ID:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "strong",
                            {
                              staticStyle: {
                                color: "#0b436a !important",
                                "font-size": "16px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.pendingOrderId))]
                          ),
                          _c("img", {
                            staticStyle: {
                              cursor: "pointer",
                              "vertical-align": "middle",
                              width: "18px",
                              height: "18px",
                              "margin-left": "8px",
                              "margin-top": "-5px",
                            },
                            attrs: { src: _vm.ic_copy, alt: "Copy ID" },
                            on: { click: _vm.copyOrderId },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center pt-5" },
                    [
                      _c("smart-btn", {
                        attrs: {
                          type: "primary",
                          label: "Go to Spot Market Dashboard",
                        },
                        on: { click: _vm.closeSuccessDialog },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500" },
              model: {
                value: _vm.showErrorDialog,
                callback: function ($$v) {
                  _vm.showErrorDialog = $$v
                },
                expression: "showErrorDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "br-10 px-5 pt-5 pb-6" },
                [
                  _c("v-card-title", { staticClass: "justify-center" }, [
                    _c(
                      "label",
                      { staticClass: "headline base header modal-popup-title" },
                      [_vm._v("Truckload Quote Request")]
                    ),
                  ]),
                  _c("v-card-text", { staticClass: "ta-c pt-5 pb-2" }, [
                    _c("label", { staticClass: "base" }, [
                      _vm._v(_vm._s(_vm.errorMessage)),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center pt-5" },
                    [
                      _c("smart-btn", {
                        attrs: { type: "primary", label: "Close" },
                        on: { click: _vm.closeErrorDialog },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "400" },
              model: {
                value: _vm.showClearConfirmDialog,
                callback: function ($$v) {
                  _vm.showClearConfirmDialog = $$v
                },
                expression: "showClearConfirmDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "br-10 px-5 pt-5 pb-6" },
                [
                  _c("v-card-title", { staticClass: "justify-center" }, [
                    _c(
                      "label",
                      { staticClass: "headline base header modal-popup-title" },
                      [_vm._v("Clear Form?")]
                    ),
                  ]),
                  _c("v-card-text", { staticClass: "ta-c pt-5 pb-2" }, [
                    _c("label", { staticClass: "base" }, [
                      _vm._v(
                        "Are you sure you want to clear the current form? This action cannot be undone."
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center pt-6" },
                    [
                      _c("smart-btn", {
                        staticClass: "mr-4",
                        attrs: {
                          type: "secondary",
                          outlined: "",
                          label: "Cancel",
                        },
                        on: { click: _vm.cancelClear },
                      }),
                      _c("smart-btn", {
                        staticStyle: { width: "85px" },
                        attrs: { type: "danger", label: "Clear" },
                        on: { click: _vm.confirmClear },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("address-book-popup", {
            attrs: {
              display: _vm.showOrigAddressBookPopup,
              selectedUserId: _vm.user.userId,
              selectedAccountId: _vm.user.accountId,
            },
            on: {
              hide: function ($event) {
                _vm.showOrigAddressBookPopup = false
              },
              selected: function (x) {
                return _vm.origLocationFromAddressBookSelected(x)
              },
            },
          }),
          _c("address-book-popup", {
            attrs: {
              display: _vm.showDestAddressBookPopup,
              selectedUserId: _vm.user.userId,
              selectedAccountId: _vm.user.accountId,
            },
            on: {
              hide: function ($event) {
                _vm.showDestAddressBookPopup = false
              },
              selected: function (x) {
                return _vm.destLocationFromAddressBookSelected(x)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }